import { render, staticRenderFns } from "./RegisterCarCode.vue?vue&type=template&id=70650f0d&scoped=true&"
import script from "./RegisterCarCode.vue?vue&type=script&lang=js&"
export * from "./RegisterCarCode.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCarCode.vue?vue&type=style&index=0&id=70650f0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70650f0d",
  null
  
)

export default component.exports